<template>
  <div>
    <vue-tailwind-datepicker
      :default-value="dateValue"
      @update:modelValue="handleDateChanged"
      :formatter="formatter"
      as-single
      placeholder=" "
      v-slot="{ value, placeholder }"
      :disable-date="isDateDisabled"
      :disabled="disabled"
    >
      <div @click="handleOpenClick" class="flex">
        <button
          :class="{
            'bg-sky-100 text-sky-800': !props.blank && dateValue.length > 0,
            'text-gray-900 rounded-sm border-transparent bg-gray-100 hover:bg-sky-100 transition py-2 px-3 sm:text-sm':
              !props.blank,
            'text-sm text-gray-500 font-medium': props.blank,
            '!cursor-not-allowed opacity-60': disabled,
            'enabled:hover:text-gray-900 group': !disabled,
          }"
          class="flex items-center"
          :value="value || placeholder"
          :disabled="disabled"
        >
          <span class="flex whitespace-nowrap items-center">
            <CalendarIcon
              class="h-5 w-5 text-gray-500"
              :class="{ 'group-hover:text-gray-900': !disabled }"
              v-if="props.blank"
            />
            <span class="ml-2">
              {{
                dateValue?.length === 0
                  ? props.blank
                    ? t("components.inputs.expansion.no_value")
                    : t("validation.attributes.schedule_for")
                  : format(new Date(dateValue), "LLL d")
              }}
            </span>
          </span>
          <span class="ml-2" v-if="!props.blank">
            <ChevronDownIcon
              v-if="dateValue.length === 0"
              class="h-5 w-5 text-gray-900"
              aria-hidden="true"
            />
            <XMarkIcon
              v-else
              @click.prevent="clear"
              class="h-5 w-5 text-sky-800"
              aria-hidden="true"
            />
          </span>
        </button>
      </div>
    </vue-tailwind-datepicker>
  </div>
</template>

<script setup>
import { format } from "date-fns";
import { ChevronDownIcon, XMarkIcon } from "@heroicons/vue/20/solid";
import { CalendarIcon } from "@heroicons/vue/24/outline";
import VueTailwindDatepicker from "vue-tailwind-datepicker";
import { computed, defineEmits, defineProps, ref } from "vue";
import { useUTC } from "@/Tailwind/Mixins/useUTC";
import { useI18n } from "vue-i18n";

const formatter = ref({
  date: "DD MMM YYYY",
  month: "MMM",
});

const { t } = useI18n();

const emit = defineEmits(["change"]);
const props = defineProps({
  blank: Boolean,
  scheduleDate: String,
  disabled: Boolean,
});

const { fromUTC } = useUTC();

const isDateDisabled = (date) => {
  const past = new Date();

  past.setDate(past.getDate() - 1);
  return date < past;
};

const dateValue = computed(() =>
  props.scheduleDate ? fromUTC(props.scheduleDate).toISOString() : ""
);

function handleDateChanged(date) {
  emit("change", date);
}

const clear = () => {
  emit("change", null);
};

const handleOpenClick = (event) => {
  if (props.disabled) {
    event.preventDefault();
    event.stopPropagation();
  }
};
</script>
